import dashboard from './translation.json';

export default {
    dashboard
};
